export default from './Search';



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/Search/index.js